import { RecoveryPVIRadius, RecoveryPVISource } from "constants/charts.enums";

const SOURCE_SUFFIX: Record<RecoveryPVISource, string> = {
  [RecoveryPVISource.AllSources]: "All",
  [RecoveryPVISource.Private]: "Private",
  [RecoveryPVISource.EvaResearch]: "Default"
};

const RADIUS_PREFIX: Record<RecoveryPVIRadius, string> = {
  [RecoveryPVIRadius.Gross]: "ThreedvGross",
  [RecoveryPVIRadius.SweetSpot]: "ThreedvSweetSpot",
  [RecoveryPVIRadius.LandingZone]: "ThreedvLandingZone"
};

export function getRecoveryTimeFields(
  radius: RecoveryPVIRadius,
  source: RecoveryPVISource,
  product = "Oil"
): string[] {
  const prefix = RADIUS_PREFIX[radius];
  const suffix = SOURCE_SUFFIX[source];
  // Gas recovery factor divides gas cum by OGIP; Oil (+ Cond) divides by OOIP.
  const volume = product === "Gas" ? "OGIP" : "OOIP";
  return [`${prefix}.${volume}_${suffix}`];
}
